<template lang="html">

  <section class="contenedor-tabla" :style="styles.colorBasic">

    <h2 class="ficha-title" :style="styles.colorBasic">Listado de prácticas</h2>

    <div class="contenedor-buscador">
      <input type="text" :style="styles.input_black" placeholder="Escribe para buscar" v-model="search">
    </div>

    <div class="scroll-table">

      <div class="contenedor-tabla row-start ais" :type="$route.name" v-if="!!dataSelected">

        <template v-if="dataSelected.length > 0">

          <template v-for="(data,key) in dataSelected">

            <grid-responsive-el :data="data"></grid-responsive-el>
            
          </template>

        </template>

        <template v-else>
          NO HAY DATOS
        </template>

      </div>

    </div>

  </section>

</template>

<script lang="js">

  import Vue from 'vue';


  import router from '@/router';

  import {mapGetters, mapActions} from 'vuex';

  import next  from '@/components/parts/icons/next';

  import gridResponsiveEl from '@/components/parts/grid-responsive-el';

  export default  {
    name: 'contenedor-tabla-responsive',
    methods:{
      ...mapActions(['toggleFavoritos'])
    },
    computed: {
      ...mapGetters({
        styles : 'getStyles',
        colors : 'basicColors',
        validaciones : 'getValidaciones',
        validacionesPorEstados : 'getValidacionesPorEstados',
        tutoradas : 'getTutoradas',
        tutoradasPorEstados : 'getTutoradasPorEstados',
        asignaciones : 'getAsignaciones',
        asignacionesPorEstados : 'getAsignacionesPorEstados',
        favoritos : 'getFavoritos',
        getEncabezados : 'getEncabezados'
      }),
      dataSelected : function(){

        let selected= new Array();

        if(this.$route.name == 'validaciones'){
          selected = (!!this.$route.params.status) ? this.validacionesPorEstados[this.$route.params.status] : this.validaciones;
        }else if (this.$route.name == 'tutorados'){
          selected = (!!this.$route.params.status) ? this.tutoradasPorEstados[this.$route.params.status] : this.tutoradas;
        }else if (this.$route.name == 'asignaciones'){
          selected = (!!this.$route.params.status) ? this.asignacionesPorEstados[this.$route.params.status] : this.asignaciones;
        }

        if(!!this.search){

          let provisional = new Array();

          selected.forEach(e => {
            let el = Object.values(e);
            el = el.filter(d => typeof(d) == "string");
            if(el.some(d => d.toLowerCase().includes(this.search.toLowerCase()))){
              if(!provisional.some(p => {p.idPractica == e.idPractica})){
                provisional.push(e);
              }
            }
          });

          selected = provisional;

        }
        
        return selected;
      }
    },
    components :{
      'next' : next,
      'grid-responsive-el':gridResponsiveEl 
    },
    data() {
      return {
        search : ''
      }
    }
  }
</script>

<style scoped lang="scss">

  .scroll-table{
    width: 100%;
    height: 100%;
    min-height: 100%;
    overflow: scroll;
    overflow-x: hidden;
    display: inline-block;
    max-height: calc(100vh - 189px);
  }

  .contenedor-buscador{
    width: 100%;
    display: inline-block;
    margin-bottom: 0px;
    input{
      height: 30px;
      line-height: 30px;
      width: 100%;
      display: inline-block;
      text-align: left;
      border: none;
      outline: none;
      border-radius: 0;
    }
  }

  @media screen and (max-width: 600px){
    .scroll-table{
      max-height: calc(100vh - 169px);
    }
  }

  .ficha-title{
    margin-top: 0;
    margin-bottom: 0;
  }


</style>



// WEBPACK FOOTER //
// src/components/views/contenedor-tabla-responsive.vue